import api from '../utils/api';

// Fetch all announcements
export const getAnnouncements = async (headers) => {
  try {
    const response = await api.get('/api/announcements', headers);
    return response.data;
  } catch (error) {
    console.error('Error fetching announcements:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific announcement by ID
export const getAnnouncementById = async (id, headers) => {
  try {
    const response = await api.get(`/api/announcements/${id}`, headers);
    console.log("announcements", response)
    return response.data;
  } catch (error) {
    console.error(`Error fetching announcement with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new announcement
export const createAnnouncement = async (announcementData, headers) => {
  try {
    const response = await api.post('/api/announcements', announcementData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating announcement:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing announcement
export const updateAnnouncement = async (id, announcementData, headers) => {
  try {
    const response = await api.put(`/api/announcements/${id}`, announcementData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating announcement with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete an announcement
export const deleteAnnouncement = async (id, headers) => {
  try {
    const response = await api.delete(`/api/announcements/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting announcement with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
